import { RawAxios, SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const BASE_PATH = `${API_ROOT}/track`;
const PATHS = {
    PAGE_RENDERING_ERROR_EVENT: `${BASE_PATH}/pre`,
    PAGE_VIEW_EVENT: `${BASE_PATH}/pv`,
    JS_ERROR_EVENT: `${BASE_PATH}/jse`,
};
async function emitPageRenderingErrorEvent(csrfToken, props) {
    const headers = csrfToken ? { headers: { 'X-CSRF-Token': csrfToken } } : {};
    return (await (await SecureAxios()).post(PATHS.PAGE_RENDERING_ERROR_EVENT, { ...props }, headers)).data;
}
async function emitPageViewEvent(csrfToken, props) {
    const headers = csrfToken ? { headers: { 'X-CSRF-Token': csrfToken } } : {};
    return (await (await SecureAxios()).post(PATHS.PAGE_VIEW_EVENT, { ...props }, headers)).data;
}
async function emitJsErrorEvent(csrfToken, props) {
    const axiosInstance = csrfToken ? SecureAxios : RawAxios;
    const headers = csrfToken ? { headers: { 'X-CSRF-Token': csrfToken } } : {};
    return (await (await axiosInstance()).post(PATHS.JS_ERROR_EVENT, { ...props }, headers)).data;
}
export default { emitPageRenderingErrorEvent, emitPageViewEvent, emitJsErrorEvent };
